import { render } from "./BoardMembers.vue?vue&type=template&id=08b382aa"
import script from "./BoardMembers.vue?vue&type=script&lang=js"
export * from "./BoardMembers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__